function renderRichtextFieldChangeHandlerTemplate({
  indent,
  defaultValueFromHandler
}: {
  indent: string
  defaultValueFromHandler: string
}): string {
  return `(value) => {
${indent}            ${defaultValueFromHandler}(value)
${indent}            formField.onChange(value)
${indent}          }`
}

function renderRichtextFieldFormFieldTemplate({
  indent,
  fieldName,
  fillFormItemProps,
  labelWithDescription,
  onChange,
  fillControlClass,
  toLowerCase
}: {
  indent: string
  fieldName: string
  fillFormItemProps: string
  labelWithDescription: string
  onChange: string
  fillControlClass: string
  toLowerCase: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${fillFormItemProps}>
${indent}      ${labelWithDescription}
${indent}      <FormControl>
${indent}        <ContentEditor
${indent}          value={formField.value}
${indent}          onChange={${onChange}}
${indent}          defaultMode="rich"
${indent}          className="${fillControlClass}"
${indent}          placeholder="Enter ${toLowerCase}"
${indent}        />
${indent}      </FormControl>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}

export function renderRichtextFieldRenderer(
  request:
    | {
        kind: 'renderRichtextFieldChangeHandlerTemplate'
        props: {
          indent: string
          defaultValueFromHandler: string
        }
      }
    | {
        kind: 'renderRichtextFieldFormFieldTemplate'
        props: {
          indent: string
          fieldName: string
          fillFormItemProps: string
          labelWithDescription: string
          onChange: string
          fillControlClass: string
          toLowerCase: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderRichtextFieldChangeHandlerTemplate':
      return renderRichtextFieldChangeHandlerTemplate(request.props)
    case 'renderRichtextFieldFormFieldTemplate':
      return renderRichtextFieldFormFieldTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
